import { Flex as AntFlex } from 'antd'
import styled from 'styled-components'

import type { T_FlexProps } from '@/components/flex/flex'


export const SC_Flex = styled(
  (props: T_FlexProps) => <AntFlex {...props} />)`
`
